<template>
	<el-dialog append-to-body :title="$t('selectMember.selectMembers')" :visible.sync="visiableAddMember" :before-close="handleClose" width="600px">
		<div class="group-chat-member">
			<div class="text">{{ $t("selectMember.chosen") }}</div>
			<div class="members">
				{{ showSelectName(checkContactsList) }}
			</div>
		</div>
		<slot></slot>
		<el-tabs v-loading="loading" type="border-card">
			<el-tab-pane :label="$t('selectMember.contactPerson')">
				<!-- 客户列表 -->
				<el-tree :data="contacts" :props="{ children: 'users', label: 'nick_name' }" class="tree">
					<span class="el-tree-node-label node-label" slot-scope="{ node, data }">
						<span v-if="data.sales_group"> {{ data.customer_id | removeFrontZero }} {{ data.customer_name }} </span>
						<span v-if="!data.sales_group" class="contacts-user">
							<el-checkbox
								:true-label="data.id"
								:false-label="data.id.split('').reverse().join('')"
								:checked="isCheck(data.id)"
								:disabled="isDisabled(data.id)"
								@change="selectMembersHandle"
							>
							</el-checkbox>
							<ChatAvatar class="avatar" :avatar="data.avatar_url" size="14" borderRadius="50%"></ChatAvatar>
							{{ data.nick_name }}
						</span>
					</span>
				</el-tree>
			</el-tab-pane>
			<!-- 销售列表 -->
			<el-tab-pane :label="$t('selectMember.salesperson')">
				<el-tree :data="sales" :props="{ label: 'username' }" class="tree">
					<span class="el-tree-node-label node-label" slot-scope="{ data }">
						<el-checkbox
							:true-label="data.id"
							:false-label="data.id.split('').reverse().join('')"
							:checked="isCheck(data.id)"
							:disabled="isDisabled(data.id)"
							@change="selectMembersHandle"
						>
							{{ data.username }}
						</el-checkbox>
					</span>
				</el-tree>
			</el-tab-pane>
		</el-tabs>

		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose()">{{ $t("common.cancel") }}</el-button>
			<el-button type="primary" @click="createGroupChat()">{{ $t("common.confirm") }}</el-button>
		</span>
	</el-dialog>
</template>

<script>
const GROUP_CHAT_NAME_MAX_LENGHT = 20;

import ChatAvatar from "./chat-avatar";

import { getContacts } from "@/services/api-v2/api-v2";

import { getSales } from "@/services/api/api";

export default {
	name: "SelectMember",

	components: {
		ChatAvatar,
	},

	props: ["membersId", "visiableAddMember"],

	created: function () {
		this.loading = true;
		this.checkContactsList = JSON.parse(JSON.stringify(this.membersId));
		this.initContacts();
		this.initSales();
		this.loading = false;
	},

	data() {
		return {
			loading: false,
			contacts: [],
			sales: [],
			checkContactsList: [], // 选中联系人列表
			dialogVisible: false, // 显示
		};
	},

	methods: {
		initContacts() {
			const _this = this;
			getContacts().then((respone) => {
				_this.contacts = respone.data;
			});
		},

		initSales() {
			const _this = this;
			getSales().then((respone) => {
				_this.sales = respone.data;
			});
		},

		// 关闭
		handleClose(done) {
			this.$emit("select-member-close-click");
		},

		// 勾选处理
		selectMembersHandle(id) {
			const reverseId = id.split("").reverse().join("");

			const isCheck = this.checkContactsList.filter((value) => value === reverseId);

			// 取消选择
			if (isCheck.length > 0) {
				return (this.checkContactsList = this.checkContactsList.filter((value) => value !== reverseId));
			}

			// 勾选成员
			this.checkContactsList.push(id);
		},

		// 勾选标识
		isCheck(contactId) {
			const result = this.checkContactsList.filter((value) => value === contactId);
			return result.length === 1 ? true : false;
		},

		// 是否禁用checkbox
		isDisabled(contactId) {
			const result = this.membersId.filter((value) => value === contactId);
			return result.length === 1 ? true : false;
		},

		// 显示已经选择的用户名
		showSelectName(checkContactsList) {
			const nickeNames = this.getNickNames(checkContactsList);
			return nickeNames.join(",");
		},

		getNickNames(userIds) {
			const nickeNames = [];
			const contacts = this.contacts;
			const sales = this.sales;

			// 先遍历联系人数据
			contacts.forEach((group) => {
				const matchUser = group.users.forEach((user) => {
					if (userIds.includes(user.id)) {
						!nickeNames.includes(user.nick_name) && nickeNames.push(user.nick_name);
					}
				});
			});

			// 遍历销售数据
			sales.forEach((value) => {
				userIds.includes(value.id) && nickeNames.push(value.username);
			});

			return nickeNames;
		},

		// 获取群聊名字
		getGroupChatName(userIds) {
			const nickeNames = this.getNickNames(userIds);

			let groupChatName = this.cutGroupName(nickeNames.join(" "), GROUP_CHAT_NAME_MAX_LENGHT);

			return `${groupChatName} ${this.$t("selectMember.groupChat")}`;
		},

		// 剪切群聊名字
		cutGroupName(groupChatName, maxLenght) {
			if (groupChatName.length > maxLenght) {
				groupChatName = groupChatName.substring(0, maxLenght) + "...";
			}

			return groupChatName;
		},

		createGroupChat() {
			// 加上自己 userid
			const userIds = this.checkContactsList;
			userIds.concat(this.$store.state.user.id);

			if (userIds.length < 2) {
				this.$message({ message: this.$t("selectMember.groupChat"), type: "warning" });
				return false;
			}

			const groupChatName = this.getGroupChatName(userIds);

			this.$emit("onSubmit", {
				group_name: groupChatName,
				contacts_id: this.checkContactsList,
			});
		},
	},
};
</script>

<style lang="less" scoped>
.node-label {
	font-size: 14px;
	.contacts-user {
		line-height: 26px;
		.avatar {
			height: 20px;
			width: 20px;
			vertical-align: middle;
		}
	}
}

.select-members-box {
	position: relative;
}

.group-chat-member {
	margin: 0 0 15px 0;
	.text {
		float: left;
		min-height: 30px;
	}
	.members {
		float: left;
		margin: 0 0 0 15px;
		width: 80%;
		color: #3a8ee6;
	}
	&:after {
		display: block;
		content: "";
		clear: both;
	}
}

.tab {
	height: 520px;
	overflow: auto;
}
.footer {
	text-align: right;
	margin: 15px;
}
.tree {
	height: 400px;
	overflow: auto;
}
</style>
